module.exports = __webpack_public_path__ + "img/change.4c9c4f64.svg";